// import { useEffect, useState, useMemo } from "react";
// import { FaTrashAlt } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { db } from "../firebase/firebaseConfig";
// import {
//   collection,
//   getDoc,
//   getDocs,
//   arrayUnion,
//   deleteDoc,
//   doc,
//   updateDoc,
//   addDoc,
//   writeBatch,
// } from "firebase/firestore";
// import { useAuth } from "../context/AuthContext";
// import { toast } from "react-toastify";
// import { RingLoader } from "react-spinners";
// import { ref, deleteObject } from "firebase/storage";
// import { storage } from "../firebase/firebaseConfig";
// import { calculatePrice } from "../utility/priceCalculation";
// import { processPayment } from "../utility/razorpayService";
// import { verifyPayment } from "../utility/verifyPayment";
// import FeeBreakdown from "../components/PlatformFee";
// import { useCollege } from "../context/CollegeContext";

// const Cart = () => {
//   const [isUrgent, setIsUrgent] = useState(false);
//   const navigate = useNavigate();
//   const { setUploadedFiles } = useCollege();
//   const { currentUser, walletBalance, setWalletBalance, phoneNumber, name } = useAuth();
//   const [cartItems, setCartItems] = useState([]);
//   const [deletingItemId, setDeletingItemId] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
//   const [isVerifyingPayment, setIsVerifyingPayment] = useState(false);
//   const [useWallet, setUseWallet] = useState(false);
//   const [walletLoading, setWalletLoading] = useState(true);
//   const [discountRanges, setDiscountRanges] = useState([]);
//   const [discountLoading, setDiscountLoading] = useState(true);

//   useEffect(() => {
//     setUploadedFiles([]);
//     if (!currentUser) {
//       toast.error("Please log in to view your cart.");
//       navigate("/");
//       return;
//     }

//     const fetchCart = async () => {
//       try {
//         setLoading(true);
//         const userId = currentUser.uid;
//         const cartRef = collection(db, "Cart", userId, "Items");
//         const snapshot = await getDocs(cartRef);
//         const items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//         setCartItems(items);
//       } catch (error) {
//         console.error("Error fetching cart items:", error);
//         toast.error("Failed to fetch cart items.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCart();
//   }, [currentUser, navigate, setUploadedFiles]);

//   useEffect(() => {
//     const fetchDiscountRanges = async () => {
//       try {
//         const discountRef = doc(db, "settings", "discountRates");
//         const discountSnap = await getDoc(discountRef);

//         if (discountSnap.exists()) {
//           const data = discountSnap.data();
//           const ranges = [
//             { min: 10, max: 50, discount: data.discount10to50 || 0 },
//             { min: 51, max: Infinity, discount: data.discountAbove50 || 0 },
//           ];
//           setDiscountRanges(ranges);
//         } else {
//           toast.warn("Discount settings not found. Using default rates.");
//           setDiscountRanges([
//             { min: 10, max: 50, discount: 0 },
//             { min: 51, max: Infinity, discount: 0 },
//           ]);
//         }
//       } catch (error) {
//         console.error("Error fetching discount settings:", error);
//         toast.error("Failed to fetch discount settings.");
//       } finally {
//         setDiscountLoading(false);
//       }
//     };

//     fetchDiscountRanges();
//   }, []);

//   useEffect(() => {
//     if (currentUser) {
//       const fetchWalletBalance = async () => {
//         try {
//           const userDocRef = doc(db, "users", currentUser.uid);
//           const userDocSnap = await getDoc(userDocRef);
//           if (userDocSnap.exists()) {
//             setWalletBalance(userDocSnap.data().wallet.balance || 0);
//           } else {
//             setWalletBalance(0);
//           }
//         } catch (error) {
//           console.error("Error fetching wallet balance:", error);
//           toast.error("Failed to fetch wallet balance.");
//         } finally {
//           setWalletLoading(false);
//         }
//       };

//       fetchWalletBalance();
//     }
//   }, [currentUser, setWalletBalance]);

//   const { subtotal, discount, platformFee, finalTotal, totalPages } = useMemo(() => {
//     if (discountLoading) {
//       return {
//         subtotal: 0,
//         discount: 0,
//         platformFee: 0,
//         finalTotal: 0,
//         totalPages: 0,
//       };
//     }
//     const priceDetails = calculatePrice(cartItems, isUrgent, discountRanges);
//     return priceDetails;
//   }, [cartItems, isUrgent, discountRanges, discountLoading]);

//   const walletAmountUsed = useWallet ? Math.min(walletBalance, finalTotal) : 0;
//   const remainingAmount = Math.max(finalTotal - walletAmountUsed, 0);

//   const handleDeleteItem = async (itemId, fileURL) => {
//     try {
//       setDeletingItemId(itemId);
//       const userId = currentUser.uid;
//       const itemRef = doc(db, "Cart", userId, "Items", itemId);

//       if (fileURL) {
//         const fileRef = ref(storage, fileURL);
//         await deleteObject(fileRef).catch((error) => {
//           console.error("Error deleting file:", error);
//           throw new Error("Failed to delete file.");
//         });
//       }

//       await deleteDoc(itemRef);
//       setCartItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
//       toast.success("Item removed from cart.");
//     } catch (error) {
//       console.error("Error deleting item:", error);
//       toast.error(error.message || "Failed to remove item.");
//     } finally {
//       setDeletingItemId(null);
//     }
//   };

//   const verifyPaymentWithRetry = async (paymentId, maxRetries = 3) => {
//     let retryCount = 0;

//     while (retryCount < maxRetries) {
//       try {
//         const isVerified = await verifyPayment(paymentId);
//         if (isVerified) return true;
//       } catch (error) {
//         console.error(`Verification attempt ${retryCount + 1} failed:`, error);
//       }

//       retryCount++;
//       await new Promise((resolve) => setTimeout(resolve, 2000 * retryCount));
//     }

//     return false;
//   };

//   const executeTransactionWithRetry = async ({
//     userId,
//     userDocRef,
//     walletDeduction,
//     paymentId,
//     orderId,
//     finalTotal,
//     isUrgent,
//     phoneNumber,
//     name,
//     cartItems,
//   }) => {
//     const maxRetries = 3;
//     let retryCount = 0;
//     let lastError;

//     while (retryCount < maxRetries) {
//       try {
//         const batch = writeBatch(db);
//         const timestamp = new Date();
//         const readableTimestamp = timestamp.toLocaleString("en-IN", {
//           year: "numeric",
//           month: "2-digit",
//           day: "2-digit",
//           hour: "2-digit",
//           minute: "2-digit",
//           second: "2-digit",
//           hour12: true,
//         });

//         if (walletDeduction) {
//           batch.update(userDocRef, {
//             "wallet.balance": walletDeduction.newBalance,
//             "wallet.transactions": arrayUnion({
//               type: "payment",
//               amount: -walletDeduction.amount,
//               timestamp: walletDeduction.timestamp,
//             }),
//           });
//         }

//         const cartRef = collection(db, "Cart", userId, "Items");
//         const cartItemsSnapshot = await getDocs(cartRef);

//         cartItemsSnapshot.docs.forEach((itemDoc) => {
//           const itemRef = doc(cartRef, itemDoc.id);
//           batch.update(itemRef, {
//             paymentDone: true,
//             paymentTimestamp: readableTimestamp,
//             paymentId: paymentId || "wallet-only",
//             orderId: orderId,
//             orderTotal: finalTotal,
//             isUrgent: isUrgent,
//             orderDate: timestamp,
//             status: "Paid",
//           });
//         });

//         const userOrdersRef = collection(db, "users", userId, "orders");
//         batch.set(doc(userOrdersRef, orderId.toString()), {
//           orderId: orderId,
//           paymentId: paymentId || "wallet-only",
//           totalAmount: finalTotal,
//           date: timestamp,
//           readableDate: readableTimestamp,
//           status: "Paid",
//           isUrgent: isUrgent,
//           itemsCount: cartItems.length,
//           items: cartItems.map((item) => ({
//             id: item.id,
//             originalName: item.originalName,
//             price: item.price,
//           })),
//           userEmail: currentUser.email,
//           phone: phoneNumber,
//           name: name,
//         });

//         await batch.commit();
//         return;
//       } catch (error) {
//         lastError = error;
//         console.error(`Transaction attempt ${retryCount + 1} failed:`, error);
//         retryCount++;
//         await new Promise((resolve) => setTimeout(resolve, 1000 * Math.pow(2, retryCount)));
//       }
//     }

//     throw lastError || new Error("Transaction failed after retries");
//   };

//   const handleCheckout = async () => {
//     setIsCheckoutLoading(true);
//     setIsVerifyingPayment(false);
//     let paymentId = null;
//     let walletDeduction = null;
//     let orderId = null;

//     try {
//       if (!currentUser) {
//         toast.error("Please log in to proceed with checkout.");
//         navigate("/login");
//         return;
//       }

//       if (cartItems.length === 0) {
//         toast.error("Your cart is empty.");
//         return;
//       }

//       const userId = currentUser.uid;
//       const userDocRef = doc(db, "users", userId);
//       const userDocSnap = await getDoc(userDocRef);

//       if (!userDocSnap.exists()) {
//         toast.error("User profile not found.");
//         return;
//       }

//       if (remainingAmount > 0) {
//         const paymentResponse = await processPayment({
//           userId: currentUser.uid,
//           amount: remainingAmount,
//           purpose: "Cart Checkout",
//           email: currentUser.email,
//           phone: phoneNumber,
//           name: name,
//         });

//         if (!paymentResponse?.razorpay_payment_id) {
//           throw new Error("Payment was not completed");
//         }

//         paymentId = paymentResponse.razorpay_payment_id;
//         setIsVerifyingPayment(true);

//         const isPaymentVerified = await verifyPaymentWithRetry(paymentId);
//         if (!isPaymentVerified) {
//           throw new Error("Payment verification failed");
//         }
//       }

//       if (useWallet && walletAmountUsed > 0) {
//         walletDeduction = {
//           amount: walletAmountUsed,
//           newBalance: walletBalance - walletAmountUsed,
//           timestamp: new Date(),
//         };
//       }

//       orderId = Math.floor(100000 + Math.random() * 900000);

//       await executeTransactionWithRetry({
//         userId,
//         userDocRef,
//         walletDeduction,
//         paymentId,
//         orderId,
//         finalTotal,
//         isUrgent,
//         phoneNumber,
//         name,
//         cartItems,
//       });

//       if (walletDeduction) {
//         setWalletBalance(walletDeduction.newBalance);
//       }
//       setCartItems([]);

//       toast.success("Payment successful! Order placed.");
//       navigate("/orders");
//     } catch (error) {
//       console.error("Checkout error:", error);
//       if (paymentId) {
//         console.warn("Payment completed but order failed. Initiating refund for:", paymentId);
//         toast.error("Order failed after payment. Refund will be processed.");
//       } else {
//         toast.error(error.message || "Failed to complete checkout. Please try again.");
//       }
//     } finally {
//       setIsCheckoutLoading(false);
//       setIsVerifyingPayment(false);
//     }
//   };

//   if (discountLoading || walletLoading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
//         <RingLoader color="#4B5563" size={50} />
//         <p className="ml-4 text-gray-700 dark:text-gray-300">Loading...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen flex flex-col items-center bg-gray-50 dark:bg-gray-900 p-6 transition-colors duration-300">
//       <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">🛒 Your Cart</h2>

//       {loading ? (
//         <div className="flex items-center justify-center">
//           <RingLoader color="#4B5563" size={50} />
//         </div>
//       ) : cartItems.length === 0 ? (
//         <p className="text-gray-500 dark:text-gray-300 text-lg">Your cart is empty.</p>
//       ) : (
//         <div className="w-full max-w-6xl bg-white dark:bg-gray-800 p-6 shadow-lg rounded-xl flex flex-col md:flex-row gap-6">
//           <div className="w-full md:w-3/5 max-h-[450px] overflow-y-auto p-4 border-r border-gray-300 dark:border-gray-700">
//             {cartItems.map((item) => (
//               <div
//                 key={item.id}
//                 className={`flex flex-col md:flex-row items-center justify-between border-b border-gray-300 dark:border-gray-700 py-3 transition-all duration-300 ${
//                   deletingItemId === item.id ? "opacity-0 scale-90" : "opacity-100"
//                 }`}
//               >
//                 <div className="w-full">
//                   <h4 className="font-semibold text-lg text-gray-800 dark:text-white">
//                     {item.originalName}
//                   </h4>
//                   <div className="flex flex-wrap gap-2 text-sm text-gray-600 dark:text-gray-400">
//                     <p>📄 ColorType: {item.colorType}</p>
//                     <p>📄 Pages per Sheet: {item.pagesPerSheet}</p>
//                     <p className="font-bold">💰 Price: ₹{item.price?.toFixed(2) ?? "0.00"}</p>
//                   </div>
//                   <div className="flex flex-wrap gap-2 text-sm text-gray-600 dark:text-gray-400">
//                     <p>📏 Paper Size: {item.paperSize}</p>
//                     <p>📜 Paper Type: {item.paperType}</p>
//                     <p className="font-bold">Binding : {item.wantBinding ? "Yes" : "No"}</p>
//                   </div>
//                   <div className="flex font-bold gap-2 flex-wrap">
//                     <p className="text-indigo-600 dark:text-indigo-400">
//                       🏛️ College: {item.selectedCollege}
//                     </p>
//                     <p className="text-indigo-600 dark:text-indigo-400">
//                       📃 No. of Pages:{" "}
//                       {item.pageRange === "all"
//                         ? item.totalPages
//                         : item.pageRange || item.totalPages}
//                     </p>
//                     <p className="text-indigo-600 dark:text-indigo-400">
//                       📃 No. of copies: {item.copies}
//                     </p>
//                   </div>
//                   {item.note && (
//                     <div className="mt-2 p-3 bg-gray-100 dark:bg-gray-700 rounded-lg">
//                       <div className="flex items-center gap-2">
//                         <span className="text-indigo-600 dark:text-indigo-400 font-semibold">
//                           📝 Note:
//                         </span>
//                         <p className="text-gray-800 dark:text-gray-200 break-words">{item.note}</p>
//                       </div>
//                     </div>
//                   )}
//                   <div className="mt-2 flex gap-2">
//                     <button
//                       className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition"
//                       onClick={() => handleDeleteItem(item.id, item.fileURL)}
//                       disabled={deletingItemId === item.id}
//                     >
//                       <FaTrashAlt size={16} />
//                     </button>
//                     {deletingItemId === item.id && (
//                       <span className="text-sm text-gray-500 ml-2">Deleting...</span>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <div className="w-full md:w-2/5 p-6 bg-gray-100 dark:bg-gray-900 rounded-xl">
//             <h3 className="text-xl font-bold text-gray-800 dark:text-white">Order Summary</h3>
//             <div className="mt-4 text-lg text-gray-700 dark:text-gray-300 space-y-2">
//               <p className="flex justify-between">
//                 <span>Subtotal:</span>
//                 <span>₹{(subtotal ?? 0).toFixed(2)}</span>
//               </p>
//               {discount > 0 && (
//                 <p className="flex justify-between text-green-600">
//                   <span>Discount:</span>
//                   <span>- ₹{(discount ?? 0).toFixed(2)}</span>
//                 </p>
//               )}
//               <FeeBreakdown platformFee={platformFee} />
//               <hr className="my-2 border-gray-400 dark:border-gray-600" />
//               <p className="flex justify-between font-bold text-gray-900 dark:text-white text-xl">
//                 <span>Final Total:</span>
//                 <span>₹{(finalTotal ?? 0).toFixed(2)}</span>
//               </p>
//               <p className="text-red-500 text-sm">
//                 Note: Pricing may differ based on file content.
//               </p>
//               <div className="flex items-center mt-4">
//                 <input
//                   type="checkbox"
//                   id="urgentOrder"
//                   checked={isUrgent}
//                   onChange={(e) => setIsUrgent(e.target.checked)}
//                   className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
//                 />
//                 <label
//                   htmlFor="urgentOrder"
//                   className="ml-2 text-sm text-gray-700 dark:text-gray-300"
//                 >
//                   Urgent Order (No Refund - Extra Charge)
//                 </label>
//               </div>
//               {useWallet && (
//                 <div className="mt-4 text-lg text-gray-700 dark:text-gray-300 space-y-2">
//                   <p className="flex justify-between">
//                     <span>Wallet Deduction:</span>
//                     <span>₹{(walletAmountUsed ?? 0).toFixed(2)}</span>
//                   </p>
//                   <p className="flex justify-between">
//                     <span>Remaining Amount:</span>
//                     <span>₹{(remainingAmount ?? 0).toFixed(2)}</span>
//                   </p>
//                 </div>
//               )}
//               <div className="flex items-center mt-4">
//                 <input
//                   type="checkbox"
//                   id="useWallet"
//                   checked={useWallet}
//                   onChange={(e) => setUseWallet(e.target.checked)}
//                   disabled={walletLoading || walletBalance <= 0}
//                   className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 dark:focus:ring-indigo-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
//                 />
//                 <label
//                   htmlFor="useWallet"
//                   className="ml-2 text-sm text-gray-700 dark:text-gray-300"
//                 >
//                   {walletLoading
//                     ? "Loading Wallet..."
//                     : `Use Wallet (₹${(walletBalance ?? 0).toFixed(2)})`}
//                 </label>
//               </div>
//             </div>
//             <button
//               className="w-full mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition flex items-center justify-center disabled:bg-gray-400"
//               onClick={handleCheckout}
//               disabled={
//                 isCheckoutLoading ||
//                 isVerifyingPayment ||
//                 cartItems.length === 0 ||
//                 (useWallet && walletBalance < walletAmountUsed)
//               }
//             >
//               {isCheckoutLoading ? (
//                 <RingLoader color="#ffffff" size={24} />
//               ) : isVerifyingPayment ? (
//                 "Verifying Payment..."
//               ) : (
//                 "Checkout"
//               )}
//             </button>
//             <button
//               className="mt-4 w-full text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition"
//               onClick={() => navigate("/home")}
//             >
//               ← Add More Files
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Cart;

import { useEffect, useState, useMemo } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/firebaseConfig";
import {
  collection,
  getDoc,
  getDocs,
  arrayUnion,
  deleteDoc,
  doc,
  updateDoc,
  addDoc,
  writeBatch,
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { RingLoader } from "react-spinners";
import { ref, deleteObject } from "firebase/storage";
import { storage } from "../firebase/firebaseConfig";
import { calculatePrice } from "../utility/priceCalculation";
import { processPayment } from "../utility/razorpayService";
import { verifyPayment } from "../utility/verifyPayment";
import FeeBreakdown from "../components/PlatformFee";
import { useCollege } from "../context/CollegeContext";

const Cart = () => {
  const [isUrgent, setIsUrgent] = useState(false);
  const navigate = useNavigate();
  const { setUploadedFiles } = useCollege();
  const { currentUser, walletBalance, setWalletBalance, phoneNumber, name } = useAuth();
  const [cartItems, setCartItems] = useState([]);
  const [deletingItemId, setDeletingItemId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
  const [isVerifyingPayment, setIsVerifyingPayment] = useState(false);
  const [useWallet, setUseWallet] = useState(false);
  const [walletLoading, setWalletLoading] = useState(true);
  const [discountRanges, setDiscountRanges] = useState([]);
  const [discountLoading, setDiscountLoading] = useState(true);

  useEffect(() => {
    setUploadedFiles([]);
    if (!currentUser) {
      toast.error("Please log in to view your cart.");
      navigate("/");
      return;
    }

    const fetchCart = async () => {
      try {
        setLoading(true);
        const userId = currentUser.uid;
        const cartRef = collection(db, "Cart", userId, "Items");
        const snapshot = await getDocs(cartRef);
        const items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setCartItems(items);
      } catch (error) {
        console.error("Error fetching cart items:", error);
        toast.error("Failed to fetch cart items.");
      } finally {
        setLoading(false);
      }
    };

    fetchCart();
  }, [currentUser, navigate, setUploadedFiles]);

  useEffect(() => {
    const fetchDiscountRanges = async () => {
      try {
        const discountRef = doc(db, "settings", "discountRates");
        const discountSnap = await getDoc(discountRef);

        if (discountSnap.exists()) {
          const data = discountSnap.data();
          const ranges = [
            { min: 10, max: 50, discount: data.discount10to50 || 0 },
            { min: 51, max: Infinity, discount: data.discountAbove50 || 0 },
          ];
          setDiscountRanges(ranges);
        } else {
          toast.warn("Discount settings not found. Using default rates.");
          setDiscountRanges([
            { min: 10, max: 50, discount: 0 },
            { min: 51, max: Infinity, discount: 0 },
          ]);
        }
      } catch (error) {
        console.error("Error fetching discount settings:", error);
        toast.error("Failed to fetch discount settings.");
      } finally {
        setDiscountLoading(false);
      }
    };

    fetchDiscountRanges();
  }, []);

  useEffect(() => {
    if (currentUser) {
      const fetchWalletBalance = async () => {
        try {
          const userDocRef = doc(db, "users", currentUser.uid);
          const userDocSnap = await getDoc(userDocRef);
          if (userDocSnap.exists()) {
            setWalletBalance(userDocSnap.data().wallet.balance || 0); // In rupees
          } else {
            setWalletBalance(0);
          }
        } catch (error) {
          console.error("Error fetching wallet balance:", error);
          toast.error("Failed to fetch wallet balance.");
        } finally {
          setWalletLoading(false);
        }
      };

      fetchWalletBalance();
    }
  }, [currentUser, setWalletBalance]);

  // Calculate price details (all amounts in rupees)
  const { subtotal, discount, platformFee, finalTotal, totalPages } = useMemo(() => {
    if (discountLoading) {
      return {
        subtotal: 0,
        discount: 0,
        platformFee: 0,
        finalTotal: 0,
        totalPages: 0,
      };
    }
    const priceDetails = calculatePrice(cartItems, isUrgent, discountRanges);
    console.log("Price Details (in rupees):", priceDetails); // Debug log
    return priceDetails;
  }, [cartItems, isUrgent, discountRanges, discountLoading]);

  // Wallet calculations (all in rupees)
  const walletAmountUsed = useWallet ? Math.min(walletBalance, finalTotal) : 0;
  const remainingAmount = Math.max(finalTotal - walletAmountUsed, 0);

  const handleDeleteItem = async (itemId, fileURL) => {
    try {
      setDeletingItemId(itemId);
      const userId = currentUser.uid;
      const itemRef = doc(db, "Cart", userId, "Items", itemId);

      if (fileURL) {
        const fileRef = ref(storage, fileURL);
        await deleteObject(fileRef).catch((error) => {
          console.error("Error deleting file:", error);
          throw new Error("Failed to delete file.");
        });
      }

      await deleteDoc(itemRef);
      setCartItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
      toast.success("Item removed from cart.");
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error(error.message || "Failed to remove item.");
    } finally {
      setDeletingItemId(null);
    }
  };

  const moveCartToFinalOrder = async (userId, paymentId = null) => {
    try {
      const cartRef = collection(db, "Cart", userId, "Items");
      const finalOrderRef = collection(db, "finalOrder");
      const cartItemsSnapshot = await getDocs(cartRef);

      if (cartItemsSnapshot.empty) {
        throw new Error("Cart is empty.");
      }

      const orderId = Math.floor(100000 + Math.random() * 900000);
      const orderDate = new Date();
      const orderItems = cartItemsSnapshot.docs.map((doc) => doc.data());

      await addDoc(finalOrderRef, {
        orderId,
        userId,
        userEmail: currentUser.email,
        items: orderItems,
        totalAmount: finalTotal,
        date: orderDate,
        status: "Paid",
        isUrgent,
        phone: phoneNumber,
        name: name,
        paymentId,
      });

      const batch = writeBatch(db);
      cartItemsSnapshot.docs.forEach((item) => {
        batch.delete(doc(db, "Cart", userId, "Items", item.id));
      });
      await batch.commit();

      setCartItems([]);
    } catch (error) {
      console.error("Error moving cart to final order:", error);
      throw error;
    }
  };

//  const handleCheckout = async () => {
//    setIsCheckoutLoading(true);
//    setIsVerifyingPayment(false);

//    try {
//      if (!currentUser) {
//        toast.error("Please log in to proceed with checkout.");
//        navigate("/login");
//        return;
//      }

//      if (cartItems.length === 0) {
//        toast.error("Your cart is empty.");
//        return;
//      }

//      const userId = currentUser.uid;
//      const userDocRef = doc(db, "users", userId);
//      const userDocSnap = await getDoc(userDocRef);

//      if (!userDocSnap.exists()) {
//        toast.error("User profile not found.");
//        return;
//      }

//      // Create a batch for all database operations
//      const batch = writeBatch(db);
//      let paymentId = null;
//      let walletDeduction = null;

//      try {
//        // Process wallet deduction first (if applicable)
//        if (useWallet && walletAmountUsed > 0) {
//          walletDeduction = {
//            amount: walletAmountUsed,
//            newBalance: walletBalance - walletAmountUsed,
//            timestamp: new Date(),
//          };

//          // Add wallet update to batch
//          batch.update(userDocRef, {
//            "wallet.balance": walletDeduction.newBalance,
//            "wallet.transactions": arrayUnion({
//              type: "payment",
//              amount: -walletDeduction.amount,
//              timestamp: walletDeduction.timestamp,
//            }),
//          });
//        }

//        // Process Razorpay payment if needed
//        if (remainingAmount > 0) {
//          const paymentResponse = await processPayment({
//            userId: currentUser.uid,
//            amount: remainingAmount,
//            purpose: "Cart Checkout",
//            email: currentUser.email,
//            phone: phoneNumber,
//            name: name,
//          });

//          if (!paymentResponse?.razorpay_payment_id) {
//            throw new Error("Payment was not completed");
//          }

//          paymentId = paymentResponse.razorpay_payment_id;
//          setIsVerifyingPayment(true);

//          // Verify payment with retry logic
//          const maxRetries = 3;
//          let retryCount = 0;
//          let isPaymentVerified = false;

//          while (retryCount < maxRetries && !isPaymentVerified) {
//            try {
//              isPaymentVerified = await verifyPayment(paymentId);
//              if (isPaymentVerified) break;
//              retryCount++;
//              await new Promise((resolve) => setTimeout(resolve, 2000 * (retryCount + 1)));
//            } catch (error) {
//              console.error(`Verification attempt ${retryCount + 1} failed:`, error);
//              retryCount++;
//            }
//          }

//          if (!isPaymentVerified) {
//            throw new Error("Payment verification failed after retries");
//          }
//        }

//        // Create order document in batch
//        const finalOrderRef = collection(db, "finalOrder");
//        const orderId = Math.floor(100000 + Math.random() * 900000);
//        const orderDate = new Date();

//        batch.set(doc(finalOrderRef), {
//          orderId,
//          userId,
//          userEmail: currentUser.email,
//          items: cartItems,
//          totalAmount: finalTotal,
//          date: orderDate,
//          status: "Paid",
//          isUrgent,
//          phone: phoneNumber,
//          name: name,
//          paymentId,
//        });

//        // Delete cart items in batch
//        const cartRef = collection(db, "Cart", userId, "Items");
//        const cartItemsSnapshot = await getDocs(cartRef);
//        cartItemsSnapshot.docs.forEach((itemDoc) => {
//          batch.delete(doc(cartRef, itemDoc.id));
//        });

//        // Commit all operations as a single transaction
//        await batch.commit();

//        // Update local state only after successful commit
//        if (walletDeduction) {
//          setWalletBalance(walletDeduction.newBalance);
//        }
//        setCartItems([]);

//        toast.success("Payment successful! Order placed.");
//        navigate("/orders");
//      } catch (error) {
//        console.error("Checkout error:", error);

//        // If we have a payment ID but verification failed, we should refund
//        if (paymentId) {
//          // In a real app, you would call a refund API here
//          console.warn("Payment verification failed, refund should be initiated for:", paymentId);
//        }

//        throw error;
//      }
//    } catch (error) {
//      console.error("Checkout failed:", error);
//      toast.error(error.message || "Failed to complete checkout. Please try again.");
//    } finally {
//      setIsCheckoutLoading(false);
//      setIsVerifyingPayment(false);
//    }
//  };

const handleCheckout = async () => {
  setIsCheckoutLoading(true);
  setIsVerifyingPayment(false);
  let paymentId = null;
  let walletDeduction = null;
  let orderId = null;

  try {
    // Validate user and cart
    if (!currentUser) {
      toast.error("Please log in to proceed with checkout.");
      navigate("/login");
      return;
    }

    if (cartItems.length === 0) {
      toast.error("Your cart is empty.");
      return;
    }

    const userId = currentUser.uid;
    const userDocRef = doc(db, "users", userId);
    const userDocSnap = await getDoc(userDocRef);

    if (!userDocSnap.exists()) {
      toast.error("User profile not found.");
      return;
    }

    console.log("phonenhmber",phoneNumber);

    // Process Razorpay payment first if needed
    if (remainingAmount > 0) {
      const paymentResponse = await processPayment({
        userId: currentUser.uid,
        amount: remainingAmount,
        purpose: "Cart Checkout",
        email: currentUser.email,
        phone: phoneNumber,
        name: name,
      });

      if (!paymentResponse?.razorpay_payment_id) {
        throw new Error("Payment was not completed");
      }

      paymentId = paymentResponse.razorpay_payment_id;
      setIsVerifyingPayment(true);

      // Verify payment with retry logic
      const isPaymentVerified = await verifyPaymentWithRetry(paymentId);
      if (!isPaymentVerified) {
        throw new Error("Payment verification failed");
      }
    }

    // Process wallet deduction if applicable
    if (useWallet && walletAmountUsed > 0) {
      walletDeduction = {
        amount: walletAmountUsed,
        newBalance: walletBalance - walletAmountUsed,
        timestamp: new Date(),
      };
    }

    // Generate order ID
    orderId = Math.floor(100000 + Math.random() * 900000);
    console.log("order id ", orderId);

    // Execute the entire transaction with retries
    await executeTransactionWithRetry({
      userId,
      userDocRef,
      walletDeduction,
      paymentId,
      orderId,
      finalTotal,
      isUrgent,
      phoneNumber,
      name,
      cartItems,
    });

    // Update local state only after successful transaction
    if (walletDeduction) {
      setWalletBalance(walletDeduction.newBalance);
    }
    setCartItems([]);

    toast.success("Payment successful! Order placed.");
    navigate("/orders");
  } catch (error) {
    console.error("Checkout error:", error);

    // Handle partial failures
    if (paymentId) {
      console.warn("Payment completed but order failed. Initiating refund for:", paymentId);
      toast.error("Order failed after payment. Refund will be processed.");
    } else {
      toast.error(error.message || "Failed to complete checkout. Please try again.");
    }
  } finally {
    setIsCheckoutLoading(false);
    setIsVerifyingPayment(false);
  }
};

// Transaction handler with retries
const executeTransactionWithRetry = async ({
  userId,
  userDocRef,
  walletDeduction,
  paymentId,
  orderId,
  finalTotal,
  isUrgent,
  phoneNumber,
  name,
  cartItems,
}) => {
  const maxRetries = 3;
  let retryCount = 0;
  let lastError;

  while (retryCount < maxRetries) {
    try {
      const batch = writeBatch(db);

      // Update wallet if needed
      if (walletDeduction) {
        batch.update(userDocRef, {
          "wallet.balance": walletDeduction.newBalance,
          "wallet.transactions": arrayUnion({
            type: "payment",
            amount: -walletDeduction.amount,
            timestamp: walletDeduction.timestamp,
          }),
        });
      }

      // Create order document
      const finalOrderRef = collection(db, "finalOrder");
      batch.set(doc(finalOrderRef), {
        orderId,
        userId,
        userEmail: currentUser.email,
        items: cartItems,
        totalAmount: finalTotal,
        date: new Date(),
        status: "Paid",
        isUrgent,
        phone: phoneNumber,
        name: name,
        paymentId,
      });

      // Delete cart items
      const cartRef = collection(db, "Cart", userId, "Items");
      const cartItemsSnapshot = await getDocs(cartRef);
      cartItemsSnapshot.docs.forEach((itemDoc) => {
        batch.delete(doc(cartRef, itemDoc.id));
      });

      // Commit the batch
      await batch.commit();
      return; // Success - exit the function
    } catch (error) {
      lastError = error;
      console.error(`Transaction attempt ${retryCount + 1} failed:`, error);
      retryCount++;

      // Exponential backoff
      await new Promise((resolve) => setTimeout(resolve, 1000 * Math.pow(2, retryCount)));
    }
  }

  throw lastError || new Error("Transaction failed after retries");
};

// Payment verification with retry
const verifyPaymentWithRetry = async (paymentId, maxRetries = 3) => {
  let retryCount = 0;

  while (retryCount < maxRetries) {
    try {
      const isVerified = await verifyPayment(paymentId);
      if (isVerified) return true;
    } catch (error) {
      console.error(`Verification attempt ${retryCount + 1} failed:`, error);
    }

    retryCount++;
    await new Promise((resolve) => setTimeout(resolve, 2000 * retryCount));
  }

  return false;
};

  if (discountLoading || walletLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <RingLoader color="#4B5563" size={50} />
        <p className="ml-4 text-gray-700 dark:text-gray-300">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-50 dark:bg-gray-900 p-6 transition-colors duration-300">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">🛒 Your Cart</h2>

      {loading ? (
        <div className="flex items-center justify-center">
          <RingLoader color="#4B5563" size={50} />
        </div>
      ) : cartItems.length === 0 ? (
        <p className="text-gray-500 dark:text-gray-300 text-lg">Your cart is empty.</p>
      ) : (
        <div className="w-full max-w-6xl bg-white dark:bg-gray-800 p-6 shadow-lg rounded-xl flex flex-col md:flex-row gap-6">
          <div className="w-full md:w-3/5 max-h-[450px] overflow-y-auto p-4 border-r border-gray-300 dark:border-gray-700">
            {cartItems.map((item) => (
              <div
                key={item.id}
                className={`flex flex-col md:flex-row items-center justify-between border-b border-gray-300 dark:border-gray-700 py-3 transition-all duration-300 ${
                  deletingItemId === item.id ? "opacity-0 scale-90" : "opacity-100"
                }`}
              >
                <div className="w-full">
                  <h4 className="font-semibold text-lg text-gray-800 dark:text-white">
                    {item.originalName}
                  </h4>
                  <div className="flex flex-wrap gap-2 text-sm text-gray-600 dark:text-gray-400">
                    <p>📄 ColorType: {item.colorType}</p>
                    <p>📄 Pages per Sheet: {item.pagesPerSheet}</p>
                    <p className="font-bold">💰 Price: ₹{item.price?.toFixed(2) ?? "0.00"}</p>
                  </div>
                  <div className="flex flex-wrap gap-2 text-sm text-gray-600 dark:text-gray-400">
                    <p>📏 Paper Size: {item.paperSize}</p>
                    <p>📜 Paper Type: {item.paperType}</p>
                    <p className="font-bold">Binding : {item.wantBinding?"Yes":"No"}</p>
                  </div>
                  <div className="flex font-bold gap-2 flex-wrap">
                    <p className="text-indigo-600 dark:text-indigo-400">
                      🏛️ College: {item.selectedCollege}
                    </p>
                    <p className="text-indigo-600 dark:text-indigo-400">
                      📃 No. of Pages:{" "}
                      {item.pageRange === "all"
                        ? item.totalPages
                        : item.pageRange || item.totalPages}
                    </p>
                    <p className="text-indigo-600 dark:text-indigo-400">
                      📃 No. of copies: {item.copies}
                    </p>
                  </div>
                  {item.note && (
                    <div className="mt-2 p-3 bg-gray-100 dark:bg-gray-700 rounded-lg">
                      <div className="flex items-center gap-2">
                        <span className="text-indigo-600 dark:text-indigo-400 font-semibold">
                          📝 Note:
                        </span>
                        <p className="text-gray-800 dark:text-gray-200 break-words">{item.note}</p>
                      </div>
                    </div>
                  )}
                  <div className="mt-2 flex gap-2">
                    <button
                      className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                      onClick={() => handleDeleteItem(item.id, item.fileURL)}
                      disabled={deletingItemId === item.id}
                    >
                      <FaTrashAlt size={16} />
                    </button>
                    {deletingItemId === item.id && (
                      <span className="text-sm text-gray-500 ml-2">Deleting...</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="w-full md:w-2/5 p-6 bg-gray-100 dark:bg-gray-900 rounded-xl">
            <h3 className="text-xl font-bold text-gray-800 dark:text-white">Order Summary</h3>
            <div className="mt-4 text-lg text-gray-700 dark:text-gray-300 space-y-2">
              <p className="flex justify-between">
                <span>Subtotal:</span>
                <span>₹{(subtotal ?? 0).toFixed(2)}</span>
              </p>
              {discount > 0 && (
                <p className="flex justify-between text-green-600">
                  <span>Discount:</span>
                  <span>- ₹{(discount ?? 0).toFixed(2)}</span>
                </p>
              )}
              <FeeBreakdown platformFee={platformFee} />
              <hr className="my-2 border-gray-400 dark:border-gray-600" />
              <p className="flex justify-between font-bold text-gray-900 dark:text-white text-xl">
                <span>Final Total:</span>
                <span>₹{(finalTotal ?? 0).toFixed(2)}</span>
              </p>
              <p className="text-red-500 text-sm">
                Note: Pricing may differ based on file content.
              </p>
              <div className="flex items-center mt-4">
                <input
                  type="checkbox"
                  id="urgentOrder"
                  checked={isUrgent}
                  onChange={(e) => setIsUrgent(e.target.checked)}
                  className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <label
                  htmlFor="urgentOrder"
                  className="ml-2 text-sm text-gray-700 dark:text-gray-300"
                >
                  Urgent Order (No Refund - Extra Charge)
                </label>
              </div>
              {useWallet && (
                <div className="mt-4 text-lg text-gray-700 dark:text-gray-300 space-y-2">
                  <p className="flex justify-between">
                    <span>Wallet Deduction:</span>
                    <span>₹{(walletAmountUsed ?? 0).toFixed(2)}</span>
                  </p>
                  <p className="flex justify-between">
                    <span>Remaining Amount:</span>
                    <span>₹{(remainingAmount ?? 0).toFixed(2)}</span>
                  </p>
                </div>
              )}
              <div className="flex items-center mt-4">
                <input
                  type="checkbox"
                  id="useWallet"
                  checked={useWallet}
                  onChange={(e) => setUseWallet(e.target.checked)}
                  disabled={walletLoading || walletBalance <= 0}
                  className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 dark:focus:ring-indigo-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  htmlFor="useWallet"
                  className="ml-2 text-sm text-gray-700 dark:text-gray-300"
                >
                  {walletLoading
                    ? "Loading Wallet..."
                    : `Use Wallet (₹${(walletBalance ?? 0).toFixed(2)})`}
                </label>
              </div>
            </div>
            <button
              className="w-full mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition flex items-center justify-center disabled:bg-gray-400"
              onClick={handleCheckout}
              disabled={
                isCheckoutLoading ||
                isVerifyingPayment ||
                cartItems.length === 0 ||
                (useWallet && walletBalance < walletAmountUsed)
              }
            >
              {isCheckoutLoading ? (
                <RingLoader color="#ffffff" size={24} />
              ) : isVerifyingPayment ? (
                "Verifying Payment..."
              ) : (
                "Checkout"
              )}
            </button>
            <button
              className="mt-4 w-full text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition"
              onClick={() => navigate("/home")}
            >
              ← Add More Files
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
